import axios from "axios"

const rootUrl = process.env.REACT_APP_API_ROOT_URL
const ConfirmResApi = rootUrl + "/email-verification"

export const confirmRegisterAPI = (formDt) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axios.post(ConfirmResApi, formDt)
      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}
